import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckCircle2, XCircle } from 'lucide-react';
export function MechanismSection() {
  return <SectionWrapper bgColor="cream" data-id="element-143">
      <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-144">
        Lo Que Nadie Te Explicó Sobre Tu Hígado
      </h2>

      <div className="bg-white rounded-3xl shadow-soft overflow-hidden mb-6 border border-gray-100" data-id="element-145">
        <div className="bg-primary text-white p-6 text-center" data-id="element-146">
          <h3 className="font-serif text-xl md:text-2xl font-bold" data-id="element-147">
            🫀 TU HÍGADO ES EL DIRECTOR DE ORQUESTA DE TODO TU METABOLISMO
          </h3>
        </div>

        <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-gray-100" data-id="element-148">
          <div className="p-6 md:p-8 bg-red-50/30" data-id="element-149">
            <h4 className="font-bold text-lg text-urgency mb-4 flex items-center gap-2" data-id="element-150">
              Cuando está saturado:
            </h4>
            <ul className="space-y-4 font-sans text-gray-700" data-id="element-151">
              <li className="flex items-start gap-3" data-id="element-152">
                <XCircle className="w-5 h-5 text-urgency shrink-0 mt-0.5" data-id="element-153" />
                <span data-id="element-154">No puede quemar grasa abdominal</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-155">
                <XCircle className="w-5 h-5 text-urgency shrink-0 mt-0.5" data-id="element-156" />
                <span data-id="element-157">No puede regular tu energía</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-158">
                <XCircle className="w-5 h-5 text-urgency shrink-0 mt-0.5" data-id="element-159" />
                <span data-id="element-160">No puede eliminar toxinas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-161">
                <XCircle className="w-5 h-5 text-urgency shrink-0 mt-0.5" data-id="element-162" />
                <span data-id="element-163">No puede balancear tus hormonas</span>
              </li>
            </ul>
          </div>

          <div className="p-6 md:p-8 bg-green-50/30" data-id="element-164">
            <h4 className="font-bold text-lg text-success mb-4 flex items-center gap-2" data-id="element-165">
              Cuando está limpio:
            </h4>
            <ul className="space-y-4 font-sans text-gray-700" data-id="element-166">
              <li className="flex items-start gap-3" data-id="element-167">
                <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-168" />
                <span data-id="element-169">Quema grasa automáticamente</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-170">
                <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-171" />
                <span data-id="element-172">Produce energía celular real</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-173">
                <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-174" />
                <span data-id="element-175">Regula la inflamación</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-176">
                <CheckCircle2 className="w-5 h-5 text-success shrink-0 mt-0.5" data-id="element-177" />
                <span data-id="element-178">Estabiliza el estado de ánimo</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="font-sans text-lg text-gray-800 space-y-4 leading-relaxed" data-id="element-179">
        <p data-id="element-180">Tu hígado procesa más de 500 funciones vitales cada día.</p>

        <p data-id="element-181">
          Cuando se sobrecarga de grasa, azúcar procesada y toxinas ambientales,
          hace lo único que puede hacer: pausar el metabolismo y almacenar el
          exceso como grasa abdominal.
        </p>

        <p className="font-medium" data-id="element-182">
          No como grasa en los brazos. No como grasa en las piernas.
        </p>

        <p className="font-bold text-xl text-dark" data-id="element-183">
          Como grasa en el abdomen. Exactamente donde tú la ves cada mañana.
        </p>

        <div className="mt-5 p-5 bg-primary/10 rounded-2xl border-l-4 border-primary" data-id="element-184">
          <p className="font-serif text-xl italic text-primary" data-id="element-185">
            La inflamación que sientes no es tu cuerpo fallando. Es tu hígado
            gritando que necesita ayuda.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}